import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PrismButtonGroup from '../buttonGroup/prismButtonGroup';
import PrismButton from '../button/prismButton';
import PrismIcon from '../icon/prismIcon';

import { SORT_COLUMN_PROP_TYPES, SORT_DIRECTION_PROP_TYPES } from './constants';
import { SORT_DIRECTIONS } from '../../../constants';
import { getSortGlyph } from './utils';

class PrismSortToggleMenu extends React.PureComponent {
    static propTypes = {
        sortColumns: PropTypes.arrayOf(SORT_COLUMN_PROP_TYPES).isRequired,
        sortBy: PropTypes.string,
        sortDirection: SORT_DIRECTION_PROP_TYPES.isRequired,
        onSortSelect: PropTypes.func.isRequired,
        isOpened: PropTypes.bool
    };

    static defaultProps = {
        isOpened: false
    };

    handleSortSelect = (field, sortDirection) => {
        this.props.onSortSelect(field, sortDirection);
    }

    renderSortDirControl = (field, isActive, sortDirection) => {
        const sortSelectHandler = !isActive
            && this.handleSortSelect.bind(this, field, sortDirection);
        const glyph = getSortGlyph(sortDirection);

        return (
            <PrismButton
                className='prism-sort__toggle-menu-dir-control'
                size='sm'
                outline
                active={isActive}
                onClick={sortSelectHandler}
            >
                <PrismIcon
                    className='prism-sort__toggle-menu-dir-control-icon'
                    glyph={glyph}
                />
            </PrismButton>
        );
    }

    renderRowContent = ({ index, field, name, sortBy, sortDirection }) => {
        const isSortByField = field === sortBy;

        return (
            <tr key={`sort-row_${index}`}>
                <th className='prism-sort__toggle-menu-column'>
                    {name}
                </th>
                <th className='prism-sort__toggle-menu-column'>
                    <PrismButtonGroup className='prism-sort__toggle-menu-controls-container'>
                        {this.renderSortDirControl(field,
                            isSortByField && sortDirection === SORT_DIRECTIONS.ASC,
                            SORT_DIRECTIONS.ASC)}
                        {this.renderSortDirControl(field,
                            isSortByField && sortDirection === SORT_DIRECTIONS.DESC,
                            SORT_DIRECTIONS.DESC)}
                    </PrismButtonGroup>
                </th>
            </tr>
        )
    }

    render() {
        const {
            sortColumns,
            sortBy,
            sortDirection,
            isOpened
        } = this.props;

        const menuClassName = classNames(
            'prism-sort__toggle-menu',
            `prism-sort__toggle-menu_${isOpened ? 'opened' : 'hidden'}`
        );

        return (
            <div className={menuClassName}>
                <table className='prism-sort__toggle-menu-table'>
                    <tbody>
                        {sortColumns.map((column, index) => this.renderRowContent({index, ...column, sortBy, sortDirection}))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default PrismSortToggleMenu;
